import React from 'react';
import './App.css'; // Importa tu archivo CSS global
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import PlataformaContent from './components/main/principalSection/PrincipalContent';
import TakeControlContent from './components/main/takeControl/TakeControl';
import WhyOrkestamediaContent from './components/main/whyOrkestamedia/WhyOrkestamediaContent';
import ContactContent from './components/main/contactSection/ContactContent';
import useAlertStore from './state/alertState';
import CustomAlert from './components/main/shared/CustomAlert';

const App: React.FC = () => {
  const { showAlert } = useAlertStore();

  return (
    <div className='content'>
      <CustomAlert />
      <Header />    
      <PlataformaContent />
      <TakeControlContent />
      <WhyOrkestamediaContent />
      <ContactContent />
      <Footer />
    </div>
  );
};

export default App;